<template>
  <div class="__switch">
    <input class="__checkbox" type="checkbox" :id="id" v-model="valueInput" @change="$emit('value', valueInput)" />
    <label class="__label" :for="id">
    </label>
  </div>
</template>

<script>
export default {
  props: {
    getVmodel: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'abbc'
    }
  },

  model: {
    prop: "getVmodel",
    event: "value"
  },

  data() {
    return {
      valueInput: this.getVmodel
    }
  },

  watch: {
    getVmodel: {
      handler: function() {
        this.valueInput = this.getVmodel
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.__switch {
  width: min-content;
  height: 100%;

  display: flex;
  place-items: center;
}
input[type="checkbox"].__checkbox {
  all: unset;
  height: 0;
  width: 0;
  visibility: hidden;
}

label.__label {
  all: unset;
  cursor: pointer;
  width: 34px;
  height: 14px;
  background: rgba(0, 0, 0, 0.2);
  display: block;
  border-radius: 340px;
  position: relative;
}
label.__label:after {
  content: "";
  position: absolute;
  left: 0%;
  top: calc(50% - 20px / 2);
  width: 20px;
  height: 20px;
  background: #3e69f6;
  border-radius: 10px;
  transition: 0.3s;
}

input[type="checkbox"].__checkbox:checked + label.__label {
  background: rgba(62, 105, 246, 0.4);
}

input[type="checkbox"].__checkbox:checked + label.__label:after {
  left: calc(100% - 20px);
}
</style>
